import React from "react";

export type BrandLogoVariant = "light" | "dark" | "icon";

interface BrandLogoProps {
  /**
   * "light" = black wordmark, for green / light backgrounds (default)
   * "dark"  = green + glow wordmark, for dark backgrounds
   * "icon"  = square app-icon tile, for square / round slots (avatars, buttons)
   */
  variant?: BrandLogoVariant;
  /** Rendered height in px (width scales automatically). */
  height?: number | string;
  className?: string;
  alt?: string;
  style?: React.CSSProperties;
}

const SRC: Record<BrandLogoVariant, string> = {
  light: "/request-wordmark.png",
  dark: "/request-wordmark-dark.png",
  icon: "/logo192.png",
};

/**
 * Single source of truth for the Request brand logo.
 *
 * Two-logo rule (see CLAUDE.md, "Brand / Logo rules"): the "request" wordmark
 * is the DEFAULT logo on every surface; the "R" mark is reserved for the
 * QR-code center only. Route every in-app logo through this component so a
 * future refresh is a one-file change.
 */
const BrandLogo: React.FC<BrandLogoProps> = ({
  variant = "light",
  height,
  className,
  alt = "Request",
  style,
}) => (
  <img
    src={SRC[variant]}
    alt={alt}
    className={className}
    draggable={false}
    style={height !== undefined ? { height, width: "auto", ...style } : style}
  />
);

export default BrandLogo;
